<w-page icon="" title="" [hideFooter]="$loading() || !!$error()">

    <ng-container *w-page-header-title>
        <img src="/images/workbuddy_full_logo_blue.svg" class="logo">
        <h2>Authorisation Request</h2>
    </ng-container>

    <ng-container *w-page-body-content>

        @if ($loading()) {
            <div class="consent-loading">Loading...</div>
        } @else if ($error(); as error) {
            <div class="consent-error">{{ error }}</div>
        } @else {
            @let clientApp = $clientApp();

            <div class="consent-container">

                <legend class="legend-application">
                    @let user = $user();
                    @if (user?.imageUrl?.length) {
                        <img [src]="user.imageUrl" [alt]="user.name" class="user-avatar">
                    } @else {
                        <div class="user-avatar-fallback"><i class="fa-solid fa-user"></i></div>
                    }
                    <div class="connector"><i class="fa-solid fa-arrow-right-long"></i></div>
                    <img src="/images/workbuddy-logo.svg" alt="Workbuddy" class="wb-image">
                </legend>

                <div class="consent-description">
                    <strong>{{ clientApp?.name }}</strong> is requesting access to your WorkBuddy account
                </div>

                <w-content-list [headerTitle]="'Permissions'">
                    @for (group of $scopeGroups(); track group.group) {
                        <w-list-item [header]="group.group" [icon]="getScopeGroupIcon(group.group)" [content]="scopeContent">
                            <ng-template #scopeContent>
                                @for (scope of group.scopes; track scope.name) {
                                    <div class="scope-item">
                                        <i [class]="getScopeIcon(scope.name)"></i>
                                        <span>{{ scope.description }}</span>
                                    </div>
                                }
                            </ng-template>
                        </w-list-item>
                    }
                </w-content-list>

                <div class="consent-notice">
                    <i class="fa-solid fa-circle-info"></i>
                    <span>You can revoke access at any time from your account settings</span>
                </div>

            </div>
        }

    </ng-container>

    <ng-container *w-page-footer-left-actions>
        <w-button label="Deny" displayStyle="Secondary" (onClick)="deny()" size="Medium" iconLeft="fa-regular fa-xmark" />
        <w-button label="Approve" displayStyle="Primary" (onClick)="approve()" size="Medium" iconLeft="fa-regular fa-check" />
    </ng-container>

</w-page>
